import * as Redux from 'redux'
import * as Form from '../../components/form'
import * as Request from '../../request'
import * as Actions from './actions'
import * as Constants from './constants'
import * as Types from './types'

export const campaignsReducer = (state: Types.Campaign[] = [], action: Request.SuccessAction) => {
  switch (action.type) {
    case Request.successConstant(Constants.FETCH_CAMPAIGNS):
      return action.payload.response
    default:
      return state
  }
}

type SelectCampaignActions = Request.SuccessAction & Actions.SelectCampaign & Actions.TierClickAction
export const selectedCampaignReducer = (state: Types.Campaign | {} = {}, action: SelectCampaignActions) => {
  switch (action.type) {
    case Request.successConstant(Constants.FETCH_CAMPAIGNS):
      return (action.payload.response[0] || {})
    case Constants.SELECT_CAMPAIGN:
      return action.campaign
    case Constants.TIER_CLICK:
      return {
        ...state,
        referral_data: action.currentCampaign.referral_data.filter(
          (r) => r.referred_count >= action.clickedTier.min_count),
        selectedTier: action.clickedTier,
      }
    default:
      return state
  }
}

const initialState: Types.ViewState = {
  isLoading: false,
}
export const viewReducer = (state = initialState, action: Redux.Action) => {
  switch (action.type) {
    case Request.requestConstant(Constants.FETCH_CAMPAIGNS):
      return {
        ...state,
        isLoading: true,
      }
    case Request.successConstant(Constants.FETCH_CAMPAIGNS):
    case Request.errorConstant(Constants.FETCH_CAMPAIGNS):
      return {
        ...state,
        isLoading: false,
      }
    default:
      return state
  }
}

export const reducer = Redux.combineReducers({
  campaignForm: Form.createReducer(Constants.CAMPAIGN_FORM),
  campaigns: campaignsReducer,
  selectedCampaign: selectedCampaignReducer,
  tierForm: Form.createReducer(Constants.TIER_FORM),
  view: viewReducer,
})



// WEBPACK FOOTER //
// ./src/pages/referral-campaigns/reducer.ts